import { createContext, useContext } from "react";
import { useCancellations } from "../hooks/useCancellations";
const Context = createContext();

export const CancellationsProvider = ({ children }) => {
  return <Context.Provider value={useCancellations()}>{children}</Context.Provider>;
};

export const useCancellationsContext = () => useContext(Context);
